import React from 'react';
import { OptionTypeBase } from 'react-select';
import styled from 'styled-components';
import { SelectProps } from 'components/atoms/select';
import { GroupedDropdownSelect } from './select';

const StyledGroupedDropdownSelect = styled(GroupedDropdownSelect)`
  padding-top: var(--spacing-05);
`;

const Title = styled.div`
  padding: var(--spacing-05);
  padding-bottom: 0;
  font-weight: var(--font-weight-bold);
`;

interface ContentProps {
  title?: string | React.ReactNode;
  selectProps?: SelectProps<OptionTypeBase, true>;
  selected?: OptionTypeBase;
  onChange: (values) => void;
}

export const Content = ({
  title,
  selectProps,
  selected,
  onChange,
}: ContentProps): JSX.Element => {
  const options = [...selectProps?.options];

  return (
    <>
      {title && <Title>{title}</Title>}
      <StyledGroupedDropdownSelect
        {...selectProps}
        onChange={onChange}
        value={selected}
        options={options}
      />
    </>
  );
};
